var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTempestCompressed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 30,
    viewBox: "0 0 122 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6664_170706)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "path-typography",
    d: "M44.3179 22.0815V10.1303H39.5938V7.95081H51.4438V10.1303H46.7393V22.0815H44.3179Z",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-typography",
    d: "M50.6777 16.7718C50.6777 13.2397 53.0003 11.0579 55.9869 11.0579C58.9735 11.0579 61.0345 13.178 61.0937 16.6509V17.2161H53.0596C53.22 19.0944 54.3925 20.3656 56.2091 20.3656C57.4407 20.3656 58.3688 19.7609 58.7316 18.6897H61.0542C60.5088 20.9901 58.7119 22.3846 56.1893 22.3846C52.9189 22.3846 50.6777 20.0422 50.6777 16.7718ZM58.6329 15.5401C58.3293 14.0049 57.3815 13.0768 55.9894 13.0768C54.5973 13.0768 53.5261 14.0049 53.1633 15.5401H58.6329Z",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-typography",
    d: "M62.9512 22.081V11.3811H64.869L65.0517 12.8744C65.7181 11.8254 67.0312 11.0579 68.6256 11.0579C70.2201 11.0579 71.3308 11.8254 71.8961 13.0571C72.5008 11.9266 73.8756 11.0579 75.5713 11.0579C77.8125 11.0579 79.2465 12.6523 79.2465 14.9552V22.081H76.8449V15.0761C76.8449 13.884 76.1192 13.1188 74.9666 13.1188C73.3326 13.1188 72.3009 14.1901 72.2811 15.6019V22.0835H69.8993V15.0786C69.8993 13.8865 69.1736 13.1213 68.0209 13.1213C66.3845 13.1213 65.3552 14.1925 65.3355 15.6043V22.0859H62.9536L62.9512 22.081Z",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-typography",
    d: "M81.543 26.1197V11.3818H83.4608L83.7027 13.1392C84.4086 11.8878 85.8031 11.0609 87.4988 11.0609C90.3249 11.0609 92.3242 13.3614 92.3242 16.6737C92.3242 19.9861 90.325 22.3877 87.4791 22.3877C85.9438 22.3877 84.6727 21.7015 83.947 20.5908V26.1221H81.5454L81.543 26.1197ZM89.8807 16.6713C89.8807 14.551 88.6885 13.0775 86.9336 13.0775C85.1787 13.0775 83.9446 14.5313 83.9446 16.6095C83.9446 18.8112 85.1762 20.3638 86.9533 20.3638C88.7305 20.3638 89.8807 18.8507 89.8807 16.6688V16.6713Z",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-typography",
    d: "M93.6152 16.7718C93.6152 13.2397 95.9378 11.0579 98.9244 11.0579C101.911 11.0579 103.972 13.178 104.031 16.6509V17.2161H95.9971C96.1575 19.0944 97.3299 20.3656 99.1465 20.3656C100.378 20.3656 101.306 19.7609 101.669 18.6897H103.992C103.446 20.9901 101.649 22.3846 99.1268 22.3846C95.8564 22.3846 93.6152 20.0422 93.6152 16.7718ZM101.57 15.5401C101.267 14.0049 100.319 13.0768 98.9269 13.0768C97.5348 13.0768 96.4636 14.0049 96.1008 15.5401H101.57Z",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-typography",
    d: "M105.344 18.6702H107.645C107.726 19.8204 108.713 20.4276 110.026 20.4276C111.238 20.4276 111.885 19.9636 111.885 19.1368C111.885 18.3099 111.199 18.147 110.271 17.8459L108.857 17.3818C107.079 16.7968 105.547 16.1897 105.547 14.2126C105.547 12.2356 107 11.0631 109.565 11.0631C112.129 11.0631 113.744 12.3762 114.028 14.7976H111.767C111.646 13.5857 110.777 13.0205 109.545 13.0205C108.496 13.0205 107.889 13.4647 107.889 14.1904C107.889 15.0172 108.817 15.2394 109.585 15.5035L110.876 15.928C112.996 16.634 114.267 17.2806 114.267 19.1984C114.267 21.1163 112.774 22.3874 110.147 22.3874C107.22 22.3874 105.485 21.0151 105.342 18.6727L105.344 18.6702Z",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-typography",
    d: "M120.425 22.0814C118.102 22.0814 116.851 20.9313 116.851 18.811V13.4006H114.973V11.3816H116.851V7.72864H119.233V11.3816H122V13.4006H119.233V18.6505C119.233 19.5589 119.697 20.0649 120.585 20.0649H121.797V22.0839H120.425V22.0814Z",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6664_170706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4009 28.3383C25.4472 29.9075 21.9923 30.2429 18.7919 29.2711C18.3034 29.1231 17.8277 28.9359 17.3693 28.7113C16.046 28.0611 14.8463 27.185 13.8242 26.1225C17.823 25.85 21.6342 24.3239 24.7159 21.7612C25.3655 21.2243 25.9665 20.6311 26.5118 19.9886L27.4681 23.1605L28.7509 27.4751C28.9607 28.0117 28.8442 28.105 28.4009 28.3383Z",
    fill: "url(#paint0_linear_6664_170706)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76162 15.5338C7.97842 13.6441 8.61598 11.8271 9.62743 10.2162L6.94532 1.21365C6.93389 1.14036 6.90535 1.07079 6.862 1.0106C6.81866 0.950407 6.76173 0.901279 6.69585 0.867202C6.62997 0.833125 6.55698 0.815058 6.48281 0.814468C6.40863 0.813878 6.33537 0.83078 6.26895 0.863805C6.24467 0.877862 6.22131 0.893441 6.199 0.910449C6.1069 0.975574 3.0171 3.9598 1.95425 5.80823C0.321659 8.72357 -1.28761 18.4725 9.25426 22.6706C7.98131 20.5221 7.45639 18.0123 7.76162 15.5338Z",
    fill: "url(#paint1_linear_6664_170706)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5293 0.32777C7.96988 1.49391 2.2558 9.89009 4.14494 17.3067C5.96412 24.7933 16.6459 27.0089 23.7127 22.4844C19.6779 24.8867 14.5236 24.0004 12.6344 20.0122C10.9085 16.3272 12.8677 11.7559 16.6459 9.47028C18.0579 8.60179 19.6764 8.1267 21.3338 8.09425C28.2373 8.02427 30.8261 15.7208 25.7885 20.8518C27.9127 18.9177 29.3734 16.3634 29.9631 13.5518C31.4792 5.7853 25.1256 -0.913806 16.5293 0.32777Z",
    fill: "url(#paint2_linear_6664_170706)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2751 4.68969C24.293 4.31518 23.2657 4.07207 22.2199 3.96669C15.1531 3.22037 8.52945 8.51463 7.7598 15.5348C7.62253 16.7001 7.66184 17.8795 7.8764 19.0332C9.08919 25.4703 15.9154 29.8652 21.7227 27.2997C26.7956 25.0408 30.7511 20.3288 31.5423 14.7196C32.0787 10.7547 30.0797 6.53219 25.2751 4.68969ZM28.3304 15.9546C27.5376 20.9923 22.0333 24.8639 16.9723 23.5578C13.5672 22.6715 11.5381 19.5463 12.0978 15.9546C12.7975 11.43 17.3221 7.83825 21.94 8.11814C26.1847 8.37467 28.9835 11.8265 28.3304 15.9546Z",
    fill: "url(#paint3_linear_6664_170706)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7135 20.1057C20.1918 23.2543 14.3611 24.8869 10.0697 24.3038C6.22145 23.7907 3.56269 22.0415 1.90677 19.7325L1.88343 19.7092C-1.14436 15.4564 -1.01126 6.80594 5.93717 1.11216C6.00029 1.06043 6.19797 0.910451 6.19797 0.910451C4.51875 2.42639 -0.47216 9.23732 2.27993 14.6948C4.09909 18.3332 8.32052 19.616 12.402 19.2894C15.4929 19.0751 18.4308 17.8639 20.7748 15.8377C20.7982 15.8377 20.7982 15.8143 20.8215 15.8143C27.4217 10.2169 27.515 1.21433 19.0489 0.18811C19.8097 0.195385 20.5677 0.281327 21.3108 0.444564C22.7944 0.738388 24.9031 1.89064 25.9526 2.96355C30.0105 6.97503 29.5909 14.8814 23.7135 20.1057Z",
    fill: "url(#paint4_linear_6664_170706)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8364 21.6451C20.309 27.0093 12.6825 27.849 6.92175 25.9131C4.09969 24.9569 1.72077 23.3476 0.251455 21.2719C0.181485 21.1553 -0.191679 20.6655 0.461359 20.3857L2.28053 19.546C2.51376 19.4294 2.65369 19.3595 3.02685 19.7093C5.40577 21.925 8.71762 22.9745 12.0061 22.9045C25.9532 22.5313 32.0869 7.74473 24.857 2.17059C23.7841 1.30765 22.1282 0.701252 21.3119 0.444702L21.4285 0.468026C23.3079 0.828948 25.0841 1.60154 26.6295 2.73033C32.3436 7.48816 31.1307 16.4907 25.8364 21.6451Z",
    fill: "url(#paint5_linear_6664_170706)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6526 2.7294C26.1705 2.37914 25.6642 2.06336 25.1377 1.78442C26.6831 2.78327 27.9569 4.14967 28.845 5.76136C31.2938 10.1693 30.1277 15.8834 26.5593 19.9882C26.0019 20.6194 25.4018 21.2116 24.7633 21.7607C21.6873 24.3331 17.873 25.8605 13.8717 26.1222C12.8773 26.1853 11.8797 26.1774 10.8864 26.0988C10.7395 26.0804 10.5903 26.0985 10.4521 26.1514C10.3138 26.2042 10.1906 26.2902 10.0934 26.4019L9.09053 27.5215C8.64739 28.0347 8.85729 28.361 9.27711 28.4543C11.9331 29.1285 14.7062 29.2003 17.3934 28.6643C19.2122 28.3201 20.9717 27.7152 22.6177 26.8684C24.4559 25.9313 26.1078 24.6668 27.4921 23.1368C29.678 20.7957 31.0943 17.841 31.5502 14.6706C32.2268 9.77286 30.2442 5.36488 26.6526 2.7294Z",
    fill: "url(#paint6_linear_6664_170706)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6664_170706",
    x1: 28.5179,
    y1: 24.9048,
    x2: 19.4094,
    y2: 24.9048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8669F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A3378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6664_170706",
    x1: 5.07624,
    y1: 15.5186,
    x2: 9.30717,
    y2: 4.58004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2306,
    stopColor: "#7756C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58822,
    stopColor: "#8D58C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE5BC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6664_170706",
    x1: 13.3678,
    y1: 2.94362,
    x2: 20.1141,
    y2: 21.4789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8669F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6664_170706",
    x1: 13.0269,
    y1: 3.99755,
    x2: 22.6323,
    y2: 20.6346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F419A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01977,
    stopColor: "#61439D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31236,
    stopColor: "#7861C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58274,
    stopColor: "#8877DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82049,
    stopColor: "#9284EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9689F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6664_170706",
    x1: 4.6869,
    y1: 20.7053,
    x2: 23.2229,
    y2: 2.16933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9689F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21588,
    stopColor: "#BA82DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49762,
    stopColor: "#E579C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64198,
    stopColor: "#F576BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99445,
    stopColor: "#F569AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F569AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6664_170706",
    x1: 5.92823,
    y1: 25.9634,
    x2: 29.0403,
    y2: 6.46247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E64DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A159EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74143,
    stopColor: "#E959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F55196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6664_170706",
    x1: 9.54402,
    y1: 24.464,
    x2: 30.3528,
    y2: 9.89349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#905DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48212,
    stopColor: "#9A59CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#B64EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87409,
    stopColor: "#E03D8C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6664_170706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6664_170706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.6814,
    height: 29.6423,
    fill: "white",
    transform: "translate(0 0.178833)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTempestCompressed);
export default __webpack_public_path__ + "static/media/logo-tempest-compressed.32afb491cb196115707154ae273fda67.svg";
export { ForwardRef as ReactComponent };